import { render, staticRenderFns } from "./notificationsEdit.vue?vue&type=template&id=760b3376&scoped=true"
import script from "./notificationsEdit.vue?vue&type=script&lang=ts"
export * from "./notificationsEdit.vue?vue&type=script&lang=ts"
import style0 from "./notificationsEdit.vue?vue&type=style&index=0&id=760b3376&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "760b3376",
  null
  
)

export default component.exports